var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('v-content',[_c('v-container',{staticClass:"pa-0",attrs:{"fluid":"","fill-height":""}},[_c('v-flex',{attrs:{"xs12":"","fill-height":""}},[_c('vue-page-transition',{staticStyle:{"height":"100%"},attrs:{"name":"zoom"}},[_c('router-view')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }